import { GuidEmpty } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared@models';
import { BaseForStepsHelper, WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';
import { SupportMethodsForStepsFromPlan } from 'wizards/helpers/support-methods-for-steps-from-plan';
import { VmwareFormModel } from 'wizards/models/VMWare/vmware-form-model';

export class VmwareModelForStepsHelper extends BaseForStepsHelper {
  public static VmwareModel: VmwareFormModel = null;

  public static VMWareModelFromPlan(plan, settings: WizardHelpersSettings = this.DefaultSettings): VmwareFormModel {
    const newPlan = plan && (plan.plan || plan.Plan);
    if (newPlan) {
      this.setThisValues(plan, settings);
      this.setStorageType(settings.mode, newPlan.ConnectionID);
      this.VmwareModel = new VmwareFormModel(this.isUnix && !this.isNetBuild);

      this.updatePlanNameStep(newPlan, settings.compName);
      this.updateWhereBackupStep(newPlan, settings);
      this.VmwareModel.compressionEncryptionStep = StepsDataFromPlanHelper.updateCompressionEncryption(
        newPlan,
        this.isNBF,
        this.isUnix && !this.isNetBuild,
        this.isCreate,
        true
      );

      this.VmwareModel.selectHostStep = StepsDataFromPlanHelper.updateSelectHost(newPlan, !this.isCreate);
      this.VmwareModel.selectVirtualMachinesStep = StepsDataFromPlanHelper.updateSelectVirtualMachines(newPlan);

      this.bucketId = this.accounts && this.isRD ? this.getBucketId(newPlan.Bucket, newPlan.SGAccountID) : newPlan.ConnectionID;

      if (this.isNBF) {
        this.VmwareModel.appAwareStep = StepsDataFromPlanHelper.updateSelectAppAware(newPlan);
        this.VmwareModel.archiveConsistencyStep = StepsDataFromPlanHelper.updateArchiveConsistency(newPlan);
        this.VmwareModel.scheduleStep = StepsDataFromPlanHelper.updateNBFSchedule(
          newPlan,
          plan.OverdueAfterSuccess,
          this.isCreate,
          this.isUnix && !this.isNetBuild,
          settings.isNBF,
          settings.validVersionForSchedule
        );
        this.VmwareModel.retentionPolicyStep = StepsDataFromPlanHelper.updateNBFRetentionPolicy(
          newPlan,
          SupportMethodsForStepsFromPlan.needShowImmutability(this.storages.CloudStorages, this.bucketId),
          this.isCreate,
          this.isUnix && !this.isNetBuild,
          this.isNBF
        );

        if (this.nbfCanHybrid && !!newPlan.HybridConnections?.length) {
          this.VmwareModel.retentionPolicyStep = StepsDataFromPlanHelper.updateNBFHybridRetentionPolicy(
            newPlan,
            this.VmwareModel.retentionPolicyStep
          );
        }
      } else {
        this.VmwareModel.retentionPolicyStep = StepsDataFromPlanHelper.updateRetentionPolicy(
          newPlan,
          this.isCreate,
          this.planType,
          this.isUnix && !this.isNetBuild
        );
        this.VmwareModel.scheduleStep = StepsDataFromPlanHelper.updateSchedule(
          newPlan,
          plan.OverdueAfterSuccess,
          this.isCreate,
          this.isUnix && !this.isNetBuild
        );
      }

      this.VmwareModel.advancedSettingsStep = StepsDataFromPlanHelper.updateAdvancedSettingsVirtual(
        newPlan,
        this.storage,
        this.isCreate,
        true,
        settings?.agentVersion
      );
      this.VmwareModel.selectVirtualDisksStep = StepsDataFromPlanHelper.updateSelectVirtualDisks(newPlan, true);

      this.VmwareModel.prePostActionsStep = StepsDataFromPlanHelper.updatePrePostActions(newPlan);
      this.VmwareModel.notificationStep = StepsDataFromPlanHelper.updateNotification(newPlan.Notification);

      if (!this.isUnix || this.isNetBuild) {
        this.VmwareModel.AvailableMachinePlans = StepsDataFromPlanHelper.updateAvailableMachinePlans(
          plan.AvailableMachinePlans,
          newPlan.ID
        );
      }
    }
    return this.VmwareModel;
  }

  public static updatePlanNameStep(newPlan, compName: string): void {
    const name = newPlan.Name || SupportMethodsForStepsFromPlan.generatePlanName(compName, this.planType, this.timeZoneOffset);
    this.VmwareModel.planNameStep = StepsDataFromPlanHelper.updatePlanNameStep(name, newPlan.SavePlanInCloud, this.isNBF);
  }

  public static updateWhereBackupStep(newPlan, settings: WizardHelpersSettings): void {
    if (!this.accounts) {
      this.updateWhereBackupStepData(newPlan, this.VmwareModel, settings);
    } else {
      const id = this.bucketId || this.getBucketId(newPlan.Bucket, newPlan.SGAccountID);
      this.updateWhereBackupStepData(newPlan, this.VmwareModel, settings, id);
      if (id && id !== GuidEmpty) {
        const storage = this.storages.CloudStorages.find((s) => s.ID === id) || this.storages.LocalStorages.find((s) => s.ID === id);
        this.storageType = storage ? storage.StorageType : this.storageType;
      }
    }
    if (!this.isRD) SupportMethodsForStepsFromPlan.getFilteredStoragesByTypes(this.storages, [StorageType.OpenStack]);
    this.VmwareModel.Storages = this.storages;
    this.VmwareModel.StoragesArray = [...this.storages.CloudStorages, ...this.storages.LocalStorages];
  }
}
